<p-button
  [label]="cta()?.content?.text"
  class="cta-content-banner-button"
  iconPos="right"
  [outlined]="false"
  [icon]="icon()"
  (onClick)="navigateTo()" />
